import React, { useEffect, useState } from "react";
import { SafeAreaView, ScrollView, StatusBar, StyleSheet, View } from "react-native";
import { Grid, Container, Row, Column } from "ui-grid";
import { domusoResponsiveStyleHelper } from "./utils/domuso-responsive";
import { BottomNav } from "../../components/layout/bottom-nav";
import { Footer } from "../../components/new/footer/footer";
import {
  NavigationTextIconButton,
  NotificationBadge,
  ProgressBarCard,
  RewardsPopup,
  Text,
  theme,
  typography,
  ProgressBadge,
} from "ui-components";
import { RewardsHeader } from "../../components/new/rewards/rewards-header";
import { translate } from "../../i18n";
import automationTestingLocators from "./utils/automation-testing-locators.json";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { RewardsData } from "../../redux/reducers/reward";
import {
  filterPendingAndEarnedRewards,
  formatDate,
  formatNumberWithCommas,
  getRewardByRewardType,
} from "./utils/helper";
import { toHumanDollars } from "../../utils/money";
import { RewardsLedgerItem } from "../../../types/db-types";
import { RewardsType } from "../../enums";
import { fetchRewardsData, updateRewardAction } from "../../redux/actions/actionCreators/reward";
import { useDispatch } from "react-redux";
import { FullScreenLoader } from "../../components/new/loader/full-screen-loader";
import { RewardsService } from "../../api/RewardsService";
import { businessLogicRewards } from "./utils/business-logic-rewards";

export const Rewards = () => {
  const cognitoUser = useSelector((state: RootState) => state.auth.cognitoUser);
  const dispatch = useDispatch();
  const rewardsApiService = new RewardsService(cognitoUser, dispatch);
  const navigation = useNavigation();
  const rewardsData = useSelector((state: RootState) => state.reward.data) as RewardsData;
  const loading = useSelector((state: RootState) => state.reward.loading);

  const allReservations = useSelector((state: RootState) => state.reservation.reservations);
  const currentReservationId = useSelector(
    (state: RootState) => state.reservation.currentReservationId
  );

  const [openPointsEarnedPopup, setOpenPointsEarnedPopup] = React.useState(false);

  const refPopupError = React.useRef<any>();
  const refPopupClaimedReward = React.useRef<any>();
  const refPopupPointsEarned = React.useRef<any>();
  const refPopupShowInterestForLeaseRenewal = React.useRef<any>();

  const [onTimePaymentPendingRewards, setOnTimePaymentPendingRewards] =
    React.useState<RewardsLedgerItem[]>();
  const [onTimePaymentEarnedRewards, setOnTimePaymentEarnedRewards] =
    React.useState<RewardsLedgerItem[]>();

  const [earlyPaymentPendingRewards, setEarlyPaymentPendingRewards] =
    React.useState<RewardsLedgerItem[]>();
  const [earlyPaymentEarnedRewards, setEarlyPaymentEarnedRewards] =
    React.useState<RewardsLedgerItem[]>();

  const [earlyPaymentReward, setEarlyPaymentReward] = React.useState<RewardsLedgerItem>();
  const [onTimePaymentReward, setOnTimePaymentReward] = React.useState<RewardsLedgerItem>();
  const [showInterestInRenewalRewardData, setShowInterestInRenewalRewardData] =
    React.useState<RewardsLedgerItem>();
  const [firstLoginReward, setFirstLoginReward] = React.useState<RewardsLedgerItem>();
  const [rewardProgressValue, setRewardProgressValue] = useState(0);
  const [currentPointsBalance, setCurrentPointsBalance] = useState(0);
  const [rewardAmount, setRewardAmount] = useState(0);
  const [totalPointsEarned, setTotalPointsEarned] = useState(0);
  const [totalPointsNeededForNextReward, setTotalPointsNeededForNextReward] = useState(0);
  const [remainingPointsNeededForNextRewards, setRemainingPointsNeededForNextRewards] = useState(0);
  const [errorMsg, setErrorMsg] = React.useState(
    "We experienced an error submitting your response. Please try again."
  );
  const [loader, setLoader] = React.useState(false);
  const [rewardClaimStatementDate, setRewardClaimStatementDate] = React.useState(new Date());
  const [accordionQuestion1Open, setAccordionQuestion1Open] = useState(false);
  const [accordionQuestion2Open, setAccordionQuestion2Open] = useState(false);

  React.useEffect(() => {
    if (openPointsEarnedPopup) {
      setTimeout(() => {
        refPopupPointsEarned?.current?.open();
      }, 500);
    }
  }, [openPointsEarnedPopup]);

  useEffect(() => {
    setEarlyPaymentReward(getRewardByRewardType(rewardsData, RewardsType?.EARLY_PAYMENT));
    setOnTimePaymentReward(getRewardByRewardType(rewardsData, RewardsType?.ON_TIME_PAYMENT));
    setShowInterestInRenewalRewardData(
      getRewardByRewardType(rewardsData, RewardsType?.SHOW_INTEREST_IN_RENEWAL)
    );
    setFirstLoginReward(getRewardByRewardType(rewardsData, RewardsType?.FIRST_LOGIN));
    setCurrentPointsBalance(rewardsData?.totalPointsCurrent);
    setTotalPointsNeededForNextReward(rewardsData?.pointsToReward);
    setTotalPointsEarned(rewardsData.totalPointsHistorical);
    setRewardAmount(rewardsData.rewardAmount);
  }, [rewardsData]);

  useEffect(() => {
    let remainingPointsNeededForNextRewards = totalPointsNeededForNextReward - currentPointsBalance;
    remainingPointsNeededForNextRewards =
      remainingPointsNeededForNextRewards <= 0 ? 0 : remainingPointsNeededForNextRewards;
    setRemainingPointsNeededForNextRewards(remainingPointsNeededForNextRewards);
    setRewardProgressValue(currentPointsBalance / totalPointsNeededForNextReward);
  }, [totalPointsNeededForNextReward, currentPointsBalance]);

  useEffect(() => {
    setLoader(loading);
  }, [loading]);

  const updateShowInterestInRenewalReward = async () => {
    try {
      const currentReservation = allReservations?.find(
        (reservation) => reservation?.id == currentReservationId
      );
      const body = {
        cognitoUser,
        propertyId: currentReservation?.property?.id || allReservations[0]?.property?.id,
        accountingId: currentReservation?.accounting_id || allReservations[0]?.accounting_id,
        ledgerItemId:
          showInterestInRenewalRewardData?.rewardId || showInterestInRenewalRewardData?.id,
        body: { redeemed_at: new Date() },
      };
      await dispatch(updateRewardAction(body));
      refPopupShowInterestForLeaseRenewal?.current?.close();
      setOpenPointsEarnedPopup(true);
    } catch (error: any) {
      if (error?.code == 500) setErrorMsg(error?.message);
      refPopupError?.current?.open();
      refPopupShowInterestForLeaseRenewal?.current?.close();
    }
  };

  const claimReward = async () => {
    try {
      setLoader(true);
      const currentReservation = allReservations?.find(
        (reservation) => reservation?.id == currentReservationId
      );
      const props = {
        cognitoUser,
        propertyId: currentReservation?.property?.id || allReservations[0]?.property?.id,
        accountingId: currentReservation?.accounting_id || allReservations[0]?.accounting_id,
        // body:{}
      };
      const claimRewardResp = await rewardsApiService.claimReward(props);
      if (claimRewardResp && claimRewardResp?.reward_claim_statement_date) {
        setRewardClaimStatementDate(
          new Date(claimRewardResp?.reward_claim_statement_date?.split("T")[0].replaceAll("-", "/"))
        );
        await dispatch(fetchRewardsData(props));
        refPopupClaimedReward?.current?.open();
      }
      setLoader(false);
    } catch (error: any) {
      if (error?.code == 500) setErrorMsg(error?.message);
      refPopupError?.current?.open();
      refPopupClaimedReward?.current?.close();
      setLoader(false);
    }
  };

  let businessLogicRewardsActions = businessLogicRewards({
    rewardsData,
  });

  const RightSideProgressItem = ({ pendingRewards, earnedRewards }: any) => (
    <View style={styles.rightSideProgressItemContainer}>
      <Text style={styles.rightSideProgressItemText}>{`Pending Rewards: ${pendingRewards}`}</Text>
      <Text style={styles.rightSideProgressItemText}>{`Earned Rewards: ${earnedRewards}`}</Text>
    </View>
  );

  useEffect(() => {
    let onTimePaymentRewardPendingAndEarnedItems = filterPendingAndEarnedRewards(
      rewardsData,
      RewardsType?.ON_TIME_PAYMENT
    );
    setOnTimePaymentEarnedRewards(onTimePaymentRewardPendingAndEarnedItems?.earned);
    setOnTimePaymentPendingRewards(onTimePaymentRewardPendingAndEarnedItems?.pending);
    let earlyPaymentRewardPendingAndEarnedItems = filterPendingAndEarnedRewards(
      rewardsData,
      RewardsType?.EARLY_PAYMENT
    );
    setEarlyPaymentEarnedRewards(earlyPaymentRewardPendingAndEarnedItems?.earned);
    setEarlyPaymentPendingRewards(earlyPaymentRewardPendingAndEarnedItems?.pending);
  }, [rewardsData]);
  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollableArea}>
        <>
          <StatusBar
            hidden={false}
            translucent={false}
            backgroundColor={theme.colors.white}
            barStyle={"dark-content"}
          />
          <View style={styles.marginTop} />
          <Grid>
            <Container>
              <RewardsHeader
                testID="rewards"
                accessibilityLabel="rewards"
                currentPoints={formatNumberWithCommas(currentPointsBalance)}
                totalPoints={formatNumberWithCommas(totalPointsEarned)}
              />

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    <View style={styles.subHeaderContainer}>
                      <Text
                        style={styles.subHeaders}
                        {...automationTestingLocators.rewards.rewardsEarnPointToWinRewardsText}>
                        {translate("rewards.earnPointsToWinRewards")}
                      </Text>
                      {/* <NavigationTextIconButton
                        text={translate("rewards.history") as string}
                        iconName="time-history"
                        buttonType="secondary"
                        onPress={() => navigation.navigate("RewardsHistory")}
                        {...automationTestingLocators.rewards
                          .rewardsHistoryNavigationTextIconButton}
                      /> */}
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    <View style={{ marginTop: 16 }}>
                      <ProgressBarCard
                        titleText={`${translate("rewards.progressBarCard.nextReward")}: `}
                        titleMain={toHumanDollars(rewardAmount)}
                        progress={currentPointsBalance / totalPointsNeededForNextReward}
                        progressStartText={`${formatNumberWithCommas(
                          remainingPointsNeededForNextRewards
                        )} ${translate("rewards.progressBarCard.pointsToNextReward")}`}
                        progressCurrentPointsText={`${formatNumberWithCommas(
                          currentPointsBalance
                        )}/`}
                        progressTotalPointsText={formatNumberWithCommas(
                          totalPointsNeededForNextReward
                        )}
                        rewardIconName="dollar-circle"
                        rewardIconSize={24}
                        {...automationTestingLocators.rewards
                          .rewardsMarkerForPointsNeededForNextReward}
                      />
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>

              {rewardProgressValue >= 1 && (
                <Row>
                  <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                  <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                    <View style={styles.inputRowInner}>
                      <View style={{ marginTop: 16 }}>
                        <NotificationBadge
                          primaryText={
                            <Text>
                              {`${translate(
                                "rewards.pendingRewardNotificationBadge.primaryText"
                              )} `}
                              <Text style={{ fontFamily: "Lato_700Bold" }}>{`(${toHumanDollars(
                                rewardAmount
                              )})`}</Text>
                            </Text>
                          }
                          backgroundColor={theme.colors.primary}
                          showRightSideButton
                          rightSideButtonText={
                            translate(
                              "rewards.pendingRewardNotificationBadge.rightSideButtonText"
                            ) as string
                          }
                          onPressRightSideButton={() => claimReward()}
                          {...automationTestingLocators.rewards
                            .rewardsPendingRewardNotificationBadge}
                        />
                      </View>
                    </View>
                  </Column>
                  <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                </Row>
              )}

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    <View style={styles.subHeaderContainer}>
                      <Text
                        style={styles.subHeaders}
                        {...automationTestingLocators.rewards.rewardsHowToEarnPointsTitleText}>
                        {translate("rewards.howToEarnPoints")}
                      </Text>
                      <Text
                        style={styles.howToEarnSecondaryText}
                        {...automationTestingLocators.rewards.rewardsRenewsEveryXMonthText}>
                        {`${translate("rewards.renewsEveryXMonths1")} ${12} ${translate(
                          "rewards.renewsEveryXMonths2"
                        )}`}
                      </Text>
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    {businessLogicRewardsActions?.onTimePaymentCard?.visible && (
                      <View style={{ marginTop: 16 }}>
                        <ProgressBadge
                          titlePrimaryText={translate("rewards.onTimePayment.titlePrimaryText")}
                          statusText={`+${formatNumberWithCommas(
                            onTimePaymentReward?.points
                          )} ${translate("rewards.onTimePayment.statusText")}`}
                          secondaryStatusText={` (${formatNumberWithCommas(
                            onTimePaymentReward?.points ? onTimePaymentReward?.points * 12 : 0
                          )} ${translate("rewards.onTimePayment.secondaryStatusText")})`}
                          rightSideItem={
                            <RightSideProgressItem
                              pendingRewards={onTimePaymentPendingRewards?.length}
                              earnedRewards={onTimePaymentEarnedRewards?.length}
                            />
                          }
                          // tertiaryStatusText={`+${500} ${translate(
                          //   "rewards.onTimePayment.tertiaryStatusText1"
                          // )} ${12} ${translate("rewards.onTimePayment.tertiaryStatusText2")}`}
                          // currentStepNumberOfSteps={2}
                          // totalNumberOfSteps={12}
                          showInfoIcon
                          tooltipBody={translate("rewards.onTimePayment.tooltipBody") as string}
                          {...automationTestingLocators.rewards.rewardsOnTimePaymentProgressBadge}
                        />
                      </View>
                    )}

                    {businessLogicRewardsActions?.earlyPaymentCard?.visible && (
                      <View style={{ marginTop: 16 }}>
                        <ProgressBadge
                          titlePrimaryText={translate("rewards.earlyPayment.titlePrimaryText")}
                          statusText={`+${formatNumberWithCommas(
                            earlyPaymentReward?.points
                          )} ${translate("rewards.earlyPayment.statusText")}`}
                          secondaryStatusText={` (${formatNumberWithCommas(
                            earlyPaymentReward?.points ? earlyPaymentReward?.points * 12 : 0
                          )} ${translate("rewards.earlyPayment.secondaryStatusText")})`}
                          rightSideItem={
                            <RightSideProgressItem
                              pendingRewards={earlyPaymentPendingRewards?.length}
                              earnedRewards={earlyPaymentEarnedRewards?.length}
                            />
                          }
                          // tertiaryStatusText={`+${500} ${translate(
                          //   "rewards.earlyPayment.tertiaryStatusText1"
                          // )} ${12} ${translate("rewards.earlyPayment.tertiaryStatusText2")}`}
                          leftSideIconName="time-history"
                          // currentStepNumberOfSteps={0}
                          // totalNumberOfSteps={12}
                          showInfoIcon
                          tooltipBody={translate("rewards.earlyPayment.tooltipBody") as string}
                          {...automationTestingLocators.rewards.rewardsEarlyPaymentProgressBadge}
                        />
                      </View>
                    )}
                    {/* <View style={{ marginTop: 16 }}>
                      <ProgressBadge
                        titlePrimaryText={translate("rewards.earlyLeaseRenewal.titlePrimaryText")}
                        statusText={`+${700} ${translate("rewards.points")}`}
                        leftSideIconName="refresh"
                        {...automationTestingLocators.rewards.rewardsLeaseRenewalProgressBadge}
                      />
                    </View> */}

                    {businessLogicRewardsActions.showInterestInRenewalCard?.visible && (
                      <View style={{ marginTop: 16 }}>
                        <ProgressBadge
                          titlePrimaryText={translate(
                            "rewards.showInterestInRenewal.titlePrimaryText"
                          )}
                          statusText={`+${formatNumberWithCommas(
                            showInterestInRenewalRewardData?.points
                          )} ${translate("rewards.points")}`}
                          showRightSideIcon
                          rightSideIconName={
                            showInterestInRenewalRewardData?.redeemed_at
                              ? "success-filled"
                              : "direction-right"
                          }
                          rightSideIconColor={
                            showInterestInRenewalRewardData?.redeemed_at
                              ? theme.colors.success
                              : theme.colors.primary
                          }
                          disabled={showInterestInRenewalRewardData?.redeemed_at ? true : false}
                          onPress={() => refPopupShowInterestForLeaseRenewal?.current?.open()}
                          activeOpacity={0.6}
                          leftSideIconName="refresh-info"
                          {...automationTestingLocators.rewards
                            .rewardsShowInterestInLeaseRenewalProgressBadgeButton}
                        />
                      </View>
                    )}
                    {businessLogicRewardsActions.firstLoginCard.visible && (
                      <View style={{ marginTop: 16 }}>
                        <ProgressBadge
                          titlePrimaryText={translate("rewards.firstLogin.titlePrimaryText")}
                          statusText={`+${formatNumberWithCommas(
                            firstLoginReward?.points
                          )} ${translate("rewards.points")}`}
                          showRightSideIcon
                          rightSideIconName="success-filled"
                          rightSideIconColor={theme.colors.success}
                          leftSideIconName="log-in"
                          {...automationTestingLocators.rewards.rewardsFirstTimeLoginProgressBadge}
                        />
                      </View>
                    )}
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    <View style={styles.subHeaderContainer}>
                      <Text
                        style={styles.subHeaders}
                        {...automationTestingLocators.rewards
                          .rewardsLearnMoreAboutRewardsProgramTitle}>
                        {translate("rewards.learnMoreAboutRewardProgram.title")}
                      </Text>
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    <View style={{ marginTop: 16 }}>
                      <ProgressBadge
                        titlePrimaryText={translate(
                          "rewards.learnMoreAboutRewardProgram.question1"
                        )}
                        showRightSideIcon
                        rightSideIconName={
                          accordionQuestion1Open ? "direction-up" : "direction-down"
                        }
                        containerStyle={{
                          borderBottomLeftRadius: accordionQuestion1Open ? 0 : 10,
                          borderBottomRightRadius: accordionQuestion1Open ? 0 : 10,
                        }}
                        rightSideIconColor={theme.colors.primary}
                        disabled={false}
                        showLeftSideIcon={false}
                        activeOpacity={0.6}
                        onPress={() => setAccordionQuestion1Open(!accordionQuestion1Open)}
                        {...automationTestingLocators.rewards
                          .rewardsLearnMoreAboutRewardsProgramQuestion1Button}
                      />
                      {accordionQuestion1Open && (
                        <View style={styles.accordionInnerContainer}>
                          <Text
                            style={styles.accordionInnerContainerBodyText}
                            {...automationTestingLocators.rewards
                              .rewardsLearnMoreAboutRewardsProgramQuestion1AnswerText}>
                            {translate("rewards.learnMoreAboutRewardProgram.answer1")}
                          </Text>
                        </View>
                      )}
                    </View>
                    <View style={{ marginTop: 16 }}>
                      <ProgressBadge
                        titlePrimaryText={translate(
                          "rewards.learnMoreAboutRewardProgram.question2"
                        )}
                        showRightSideIcon
                        rightSideIconName={
                          accordionQuestion2Open ? "direction-up" : "direction-down"
                        }
                        containerStyle={{
                          borderBottomLeftRadius: accordionQuestion2Open ? 0 : 10,
                          borderBottomRightRadius: accordionQuestion2Open ? 0 : 10,
                        }}
                        rightSideIconColor={theme.colors.primary}
                        disabled={false}
                        showLeftSideIcon={false}
                        activeOpacity={0.6}
                        onPress={() => setAccordionQuestion2Open(!accordionQuestion2Open)}
                        {...automationTestingLocators.rewards
                          .rewardsLearnMoreAboutRewardsProgramQuestion1Button}
                      />
                      {accordionQuestion2Open && (
                        <View style={styles.accordionInnerContainer}>
                          <Text
                            style={styles.accordionInnerContainerBodyText}
                            {...automationTestingLocators.rewards
                              .rewardsLearnMoreAboutRewardsProgramQuestion2AnswerText}>
                            {translate("rewards.learnMoreAboutRewardProgram.answer2")}
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>
            </Container>
          </Grid>
        </>
      </ScrollView>

      <BottomNav backgroundColor={"#F5F5F5"}></BottomNav>
      <Footer />

      <RewardsPopup
        ref={refPopupShowInterestForLeaseRenewal}
        title={`${translate(
          "rewards.popupShowInterestForLeaseRenewal.title1"
        )} ${formatNumberWithCommas(showInterestInRenewalRewardData?.points)} ${translate(
          "rewards.popupShowInterestForLeaseRenewal.title2"
        )}`}
        body={`${translate(
          "rewards.popupShowInterestForLeaseRenewal.body1"
        )} ${formatNumberWithCommas(showInterestInRenewalRewardData?.points)} ${translate(
          "rewards.popupShowInterestForLeaseRenewal.body2"
        )}`}
        height={420}
        onDismiss={() => {}}
        showButtons
        leftButtonText={
          translate("rewards.popupShowInterestForLeaseRenewal.leftButtonText") as string
        }
        rightButtonText={
          translate("rewards.popupShowInterestForLeaseRenewal.rightButtonText") as string
        }
        onPressLeftButton={updateShowInterestInRenewalReward}
        onPressRightButton={updateShowInterestInRenewalReward}
        {...automationTestingLocators.rewards
          .rewardsPopupShowInterestForLeaseRenewal}></RewardsPopup>
      <RewardsPopup
        ref={refPopupPointsEarned}
        iconColor="white"
        iconName="hoorah"
        iconHeight={93}
        iconWidth={169}
        title={`${translate("rewards.pointsEarned.title")}!`}
        subTitle={`${translate("rewards.pointsEarned.subTitle1")} ${formatNumberWithCommas(
          showInterestInRenewalRewardData?.points
        )} ${translate("rewards.pointsEarned.subTitle2")}`}
        body={`${translate("rewards.pointsEarned.body1")} ${formatNumberWithCommas(
          showInterestInRenewalRewardData?.points
        )} ${translate("rewards.pointsEarned.body2")}`}
        titleColor={theme.colors.darkYellow}
        height={350}
        onDismiss={() => {
          setOpenPointsEarnedPopup(false);
        }}
        showButtons
        showRightButton={false}
        leftButtonText={translate("rewards.pointsEarned.leftButtonText") as string}
        onPressLeftButton={() => refPopupPointsEarned?.current?.close()}
        {...automationTestingLocators.rewards.rewardsPopupPointsEarned}
      />
      <RewardsPopup
        ref={refPopupClaimedReward}
        iconStroke={theme.colors.success}
        iconColor="white"
        iconName="hoorah"
        iconHeight={93}
        iconWidth={169}
        title={`${translate("rewards.claimedReward.title")}!`}
        subTitle={`${translate("rewards.claimedReward.subTitle1")} ${toHumanDollars(
          rewardAmount
        )} ${translate("rewards.claimedReward.subTitle2")}`}
        body={`${translate("rewards.claimedReward.body1")} ${formatDate(
          rewardClaimStatementDate
        )} ${translate("rewards.claimedReward.body2")}`}
        titleColor={theme.colors.success}
        height={350}
        onDismiss={() => {}}
        showButtons
        showRightButton={false}
        leftButtonText={translate("rewards.claimedReward.leftButtonText") as string}
        onPressLeftButton={() => refPopupClaimedReward?.current?.close()}
        {...automationTestingLocators.rewards.rewardsClaimedRewardPopup}
      />
      <RewardsPopup
        iconColor={theme.colors.alert}
        iconName="warning"
        titleColor={theme.colors.alert}
        ref={refPopupError}
        title={`Submission Error`}
        body={errorMsg}
        height={310}
        onDismiss={() => {}}
        showButtons
        showRightButton={false}
        leftButtonText={"Close"}
        onPressLeftButton={() => refPopupError?.current?.close()}
        {...automationTestingLocators.rewards.rewardsErrorPopup}
      />
      <FullScreenLoader loading={loader} />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...domusoResponsiveStyleHelper({
      webPhone: {
        backgroundColor: "#F5F5F5",
      },
      webTablet: {
        backgroundColor: "#FAFAFA",
      },
      webDesktop: {
        backgroundColor: "#FAFAFA",
      },
      iosPhone: {
        backgroundColor: "#F5F5F5",
      },
      iosTablet: {
        backgroundColor: "#FAFAFA",
      },
      androidPhone: {
        backgroundColor: "#F5F5F5",
      },
      androidTablet: {
        backgroundColor: "#FAFAFA",
      },
    }),
  },
  scrollableArea: {
    ...domusoResponsiveStyleHelper({
      webPhone: { backgroundColor: "#F5F5F5", paddingBottom: 10 },
      webTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      webDesktop: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      iosPhone: { backgroundColor: "#F5F5F5", paddingBottom: 200 },
      iosTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      androidPhone: { backgroundColor: "#F5F5F5", paddingBottom: 200 },
      androidTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
    }),
  },
  scrollView: {
    flexGrow: 0,
  },
  marginTop: {
    ...domusoResponsiveStyleHelper({
      webTablet: { marginTop: 20 },
      webDesktop: { marginTop: 20 },
      iosTablet: { marginTop: 20 },
      androidTablet: { marginTop: 20 },
    }),
  },

  inputRow: {
    ...domusoResponsiveStyleHelper({
      webPhone: {},
      webTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "#F5F5F5",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      webDesktop: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "#F5F5F5",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      iosPhone: {},
      iosTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "#F5F5F5",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      androidPhone: {},
      androidTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "#F5F5F5",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
    }),
  },
  inputRowInner: {
    ...domusoResponsiveStyleHelper({
      webPhone: {},
      webTablet: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      webDesktop: {
        paddingLeft: 30,
        paddingRight: 30,
      },
      iosPhone: {},
      iosTablet: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      androidPhone: {},
      androidTablet: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    }),
  },
  subHeaderContainer: {
    flex: 1,
    flexDirection: "row",
    marginTop: 32,
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  subHeaders: {
    ...typography.title1,
    color: theme.colors.text4,
    fontWeight: "500",
    flex: 1,
  },
  howToEarnSecondaryText: {
    ...typography.body,
    color: theme.colors.text2,
  },
  accordionInnerContainer: {
    backgroundColor: theme.colors.white,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    paddingBottom: 12,
    paddingHorizontal: 12,
  },
  accordionInnerContainerBodyText: {
    ...typography.title2,
    color: theme.colors.text2,
  },
  rightSideProgressItemContainer: {
    justifyContent: "space-between",
    gap: 6,
  },
  rightSideProgressItemText: {
    ...typography.body,
    color: theme.colors.text3,
  },
});
